export default "__VITE_ASSET__CM41Oa86__"